var path = 'app/scripts/modules/cloudfoundry/serverGroup/configure/wizard/basicSettings.html';
var html = "<form name=\"form\" class=\"container-fluid form-horizontal\" ng-controller=\"cfServerGroupBasicSettingsCtrl as basicSettingsCtrl\" novalidate>\n  <div class=\"modal-body\">\n    <cf-server-group-basic-settings-selector command=\"command\" application=\"application\"></cf-server-group-basic-settings-selector>\n  </div>\n</form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/cloudfoundry/serverGroup/configure/wizard/basicSettings.html
// module id = 1651
// module chunks = 0